import {
  START_LOADING_TEMPLATE_FOLDERS,
  TEMPLATE_FOLDERS_LOAD_SUCCESS,
  TEMPLATE_FOLDERS_LOAD_FAILED,
  START_LOADING_TEMPLATE_FILES,
  TEMPLATE_FILES_LOAD_SUCCESS,
  TEMPLATE_FILES_LOAD_FAILED,
  TEMPLATE_FOLDER_CREATE_SUCCESS,
  TEMPLATE_FOLDER_UPDATE_SUCCESS,
  TEMPLATE_FOLDER_DELETE_SUCCESS,
  TEMPLATE_FILE_UPLOAD_SUCCESS,
  TEMPLATE_FILE_DELETE_SUCCESS,
  TEMPLATE_FILE_RENAME_SUCCESS,
  TEMPLATE_FOLDER_CONTENT_LOAD_SUCCESS,
  TEMPLATE_SET_CURRENT_FOLDER,
  TEMPLATE_SET_BREADCRUMB,
} from '../actions/types';

const initialState = {
  folders: [],
  files: [],
  currentFolderId: null,
  breadcrumb: [],
  loadingFolders: false,
  loadingFiles: false,
  error: null,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case START_LOADING_TEMPLATE_FOLDERS:
      return {
        ...state,
        loadingFolders: true,
      };

    case TEMPLATE_FOLDERS_LOAD_SUCCESS:
      return {
        ...state,
        folders: payload || [],
        loadingFolders: false,
      };

    case TEMPLATE_FOLDERS_LOAD_FAILED:
      return {
        ...state,
        folders: [],
        loadingFolders: false,
      };

    case START_LOADING_TEMPLATE_FILES:
      return {
        ...state,
        loadingFiles: true,
      };

    case TEMPLATE_FILES_LOAD_SUCCESS:
      return {
        ...state,
        files: payload || [],
        loadingFiles: false,
      };

    case TEMPLATE_FILES_LOAD_FAILED:
      return {
        ...state,
        files: [],
        loadingFiles: false,
      };

    case TEMPLATE_FOLDER_CONTENT_LOAD_SUCCESS:
      return {
        ...state,
        folders: payload.folders || [],
        files: payload.files || [],
        currentFolderId: payload.currentFolderId,
        breadcrumb: payload.path || [],
        loadingFolders: false,
        loadingFiles: false,
      };

    case TEMPLATE_SET_CURRENT_FOLDER:
      return {
        ...state,
        currentFolderId: payload,
      };

    case TEMPLATE_SET_BREADCRUMB:
      return {
        ...state,
        breadcrumb: payload || [],
      };

    case TEMPLATE_FOLDER_CREATE_SUCCESS:
      return {
        ...state,
        folders: [...state.folders, payload],
      };

    case TEMPLATE_FOLDER_UPDATE_SUCCESS:
      return {
        ...state,
        folders: state.folders.map(folder =>
          folder._id === payload._id ? payload : folder
        ),
      };

    case TEMPLATE_FOLDER_DELETE_SUCCESS:
      return {
        ...state,
        folders: state.folders.filter(folder => folder._id !== payload),
      };

    case TEMPLATE_FILE_UPLOAD_SUCCESS:
      return {
        ...state,
        files: [...state.files, payload],
      };

    case TEMPLATE_FILE_DELETE_SUCCESS:
      return {
        ...state,
        files: state.files.filter(file => file._id !== payload),
      };

    case TEMPLATE_FILE_RENAME_SUCCESS:
      return {
        ...state,
        files: state.files.map(file =>
          file._id === payload._id ? payload : file
        ),
      };

    default:
      return state;
  }
}
